import request from '@/utils/request'
// 获取事件列表
export function event_list(params) {
	return request({
		url: '/information/events/list',
		method: 'get',
		params: params,
	})
}

// 获取事件详情
export function event_detail(params) {
	return request({
		url: '/information/events/detail',
		method: 'get',
		params: params,
	})
}
